export const printmode = {
  printmodeHeader: "Druckmodi | Druckmodus | {n} Druckmodi",
  printmodeMethodHeader: "Verfahren | Verfahren | {n} Verfahren",
  printmodeMaterialHeader: "Materialien | Material | {n} Materialien",
  actions: {
    createNew: "Neuen anlegen",
    update: "Speichern"
  },
  name: "Name",
  basicFeatures: "Grundlegendes",
  description: "Beschreibung",
  surfaceQuality: "Oberflächenbeschaffenheit",
  applications: "Anwendungsfälle",
  ranking: "Einstufung",
  rankingLabels: {
    price: "Preis-Leistung",
    flexibility: "Flexibilität",
    stability: "Stabilität",
    precision: "Präzision",
    wearResistance: "Verschleißfestigkeit",
    heatResistance: "Hitzebeständigkeit"
  },
  technicalFeatures: "Technische Daten",
  technicalFeaturesLabels: {
    resolutionXY: "Auflösung X & Y",
    resolutionZ: "Auflösung Z",
    minFeatureSize: "Minimale Wandstärke",
    maxNumberOfParts: "Maximale Anzahl Teile",
    maxDimensions: "Bauraumgröße",
    maxDimensionLabels: {
      x: "X",
      y: "Y",
      z: "Z"
    },
    maxIncrementalMeasurement: "Kettenmaß"
  },
  maxDimensions: "Bauraumgröße",
  maxDimensionLabels: {
    x: "X",
    y: "Y",
    z: "Z"
  },
  color: "Farbe",
  availableColors: "Farben",
  chooseColor: "Farbe wählen",
  availableSurfaceFinishes: "Finishes",
  colorLabels: {
    name: "Name der Farbe",
    variableName: "Excel-Variable",
    hue: "Farbton",
    thumbnail: "Vorschaubild",
    hexcode: "Muss ein Hexadecimal-Code sein",
    choose: "Wählen",
    create: "Weitere Farbe hinzufügen",
    delete: "Farbe löschen",
    uploadImage: "Bild hochladen",
    replaceImage: "Bild Ersetzen"
  },
  material: "Material",
  materialLabels: { choose: "Material wählen", createMaterial: "Neues Material anlegen", create: "Anlegen" },
  method: "Verfahren",
  methodLabels: { choose: "Verfahren wählen", createMethod: "Neues Verfahren anlegen", create: "Anlegen" },
  whiteLabels: "White Labels",
  whiteLabelLabels: {
    choose: "Welche White Labels können dieses Verfahren ordern?",
    createWhiteLabel: "Neues White Label anlegen",
    create: "Anlegen"
  },
  processingSteps: {
    header: "Folgearbeitsschritte",
    choose: "Welche Folgearbeitsschritte sind für dieses Verfahren verfügbar?"
  },
  testPricing: "Preisberechnung",
  testPricingLabels: {
    test: "Preise berechnen",
    paramLabels: {
      params: "Test Parameter",
      dimensionX: "Abmessung X",
      dimensionY: "Abmessung Y",
      dimensionZ: "Abmessung Z",
      internalVolume: "Volumen",
      externalVolume: "Externes Volumen",
      surfaceArea: "Oberfläche",
      minX: "Min. Wandstärke X",
      maxX: "Max. Wandstärke X",
      maxY: "Max. Wandstärke Y"
    }
  },
  spreadSheetLabels: {
    defaultWhiteLabelName: "Standard",
    upload: "Excel hochladen",
    replace: "Excel ersetzen",
    delete: "Löschen",
    calculatedPrice: "Berechneter Preis",
    commission: "Provision",
    standardPrice: "Wie Standard",
    asStandard: "Wie Standard",
    isPrintable: "Ist druckbar",
    isNotPrintable: "Nicht druckbar",
    isTooSmall: "Bauteil ggf. zu klein",
    isTooLarge: "Bauteil ist zu groß",
    productionTime: "Produktionszeit",
    productionTimeDays: "0 Tage | 1 Tag | {n} Tage",
    spreadSheetMissing: "Keine Standard Excel hinterlegt",
    confirmDeleteHeadline: "Excel löschen",
    confirmDeleteMessage:
      "Soll diese Excel-Tabelle wirklich <strong>gelöscht</strong> werden?<br>Diese Aktion kann nicht rückgängig gemacht werden.",
    cancel: "Abbrechen"
  }
};
